export default __webpack_public_path__ + "static/media/KZ.T.14.Е1213.24cb54f7.svg";